/*
  GW: floating "Concierge" button (replaces the WhatsApp chat app bubble).
  Desktop: burgundy pill with brass border, label "Concierge". Mobile: burgundy circle with brass ring (icon only).
  Opens WhatsApp +1 929 626 7207 with a ready message; on product pages the message includes the product link.
  Styling: assets/gw-card.css (.gw-concierge).
*/
(function () {
  var PHONE = '19296267207';

  function buildMessage() {
    var path = window.location.pathname || '';
    if (path.indexOf('/products/') !== -1) {
      var url = window.location.origin + path;
      return "Hi Galleria, I'm interested in this piece: " + url;
    }
    return 'Hi Galleria, I have a question: ';
  }

  function init() {
    if (document.querySelector('.gw-concierge')) return;
    var a = document.createElement('a');
    a.className = 'gw-concierge';
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat with our concierge on WhatsApp');
    a.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(buildMessage());
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 5.5h16v10H9l-5 4v-14z" stroke-linejoin="round"/></svg><span class="gw-concierge__label">Concierge</span>';
    a.addEventListener('click', function () {
      a.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(buildMessage());
    });
    document.body.appendChild(a);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
